import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { useDeleteDashboardVendor } from 'api/hooks/use-dashboard-vendors'
import { useQueryClient } from 'react-query'

function DeleteVendor({ addOrRemoveVendor, vendor, dashboardId, canEdit = true}) {
  const queryClient = useQueryClient()
  const { mutate } = useDeleteDashboardVendor({
    id: vendor.dashboard_vendor_id,
    options: {
      onSuccess: () => {
        // Only remove from local state after successful API deletion
        addOrRemoveVendor(vendor)
        queryClient.invalidateQueries(
          `dashboards/${dashboardId}`
        )
      }
    }
  })

  const handleDelete = () => {
    // If persisted, delete via API; otherwise, remove from local state (staged vendor)
    if (vendor.dashboard_vendor_id) {
      mutate()
    } else {
      addOrRemoveVendor(vendor)
    }
  }

  return (
    <button
      className="btn btn-sm btn-link text-danger"
      onClick={handleDelete}
      disabled={!canEdit}
    >
      <FontAwesomeIcon icon={faTrash} />
    </button>
  )
}

export default DeleteVendor